import { type DataTableRowClickEvent } from 'primereact/datatable';

/**
 * PrimeReact fires `onRowClick` even when the click lands on the row's expander
 * toggle: the toggler button doesn't stop propagation, and there's no default
 * browser action to `preventDefault`, so the row handler runs regardless. Use
 * this to let a row's click handler ignore expander toggles.
 */
export const isRowTogglerClick = (event: DataTableRowClickEvent): boolean => {
    const target = event.originalEvent.target;
    return (
        target instanceof Element && target.closest('.p-row-toggler') != null
    );
};
